var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "conceptbox", staticStyle: { "text-align": "left" } },
    [
      _c("div", { staticClass: "box-header" }, [
        _vm._v(
          _vm._s(_vm.$t("formConcept.conceptSearchBox.subquery")) +
            " " +
            _vm._s(_vm.id)
        ),
      ]),
      _vm._v(" "),
      _c("table", [
        _c("tr", [
          _c("td", { staticClass: "fn" }, [
            _c("label", { attrs: { for: _vm.id + "main_fields" } }, [
              _vm._v(
                _vm._s(_vm.$t("formConcept.conceptSearchBox.field")) + ": "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("SelectPicker", {
                attrs: {
                  "data-width": "100%",
                  "data-id": _vm.id + "main_fields",
                  options: _vm.main_fields,
                },
                model: {
                  value: _vm.search_field,
                  callback: function ($$v) {
                    _vm.search_field = $$v
                  },
                  expression: "search_field",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { staticClass: "fn" }, [
            _c("label", { attrs: { for: _vm.id + "ac1" } }, [
              _vm._v(
                _vm._s(_vm.$t("formConcept.conceptSearchBox.concept")) + ": "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("Autocomplete", {
                staticClass: "form-control",
                attrs: {
                  id: _vm.id + "ac1",
                  placeholder: "...concept...",
                  getData: _vm.getConceptAutocompletes,
                },
                model: {
                  value: _vm.current_concept,
                  callback: function ($$v) {
                    _vm.current_concept = $$v
                  },
                  expression: "current_concept",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { staticClass: "fn" }, [
            _c("label", { attrs: { for: _vm.id + "ac2" } }, [
              _vm._v(
                _vm._s(_vm.$t("formConcept.conceptSearchBox.term")) + ": "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("Autocomplete", {
                  staticClass: "form-control",
                  attrs: {
                    placeholder: "...term...",
                    id: _vm.id + "ac2",
                    getData: _vm.getTermAutocompletes,
                  },
                  model: {
                    value: _vm.current_term,
                    callback: function ($$v) {
                      _vm.current_term = $$v
                    },
                    expression: "current_term",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: {
                        title: _vm
                          .$t("formConcept.conceptSearchBox.addToLexicon")
                          .toString(),
                      },
                      on: { click: _vm.insertTerm },
                    },
                    [_vm._v("⤿ lexicon")]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "terms" },
        _vm._l(_vm.terms, function (t) {
          return _c("div", { key: t }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checked_terms[t],
                    expression: "checked_terms[t]",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  value: t,
                  checked: Array.isArray(_vm.checked_terms[t])
                    ? _vm._i(_vm.checked_terms[t], t) > -1
                    : _vm.checked_terms[t],
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.checked_terms[t],
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = t,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.checked_terms, t, $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.checked_terms,
                            t,
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.checked_terms, t, $$c)
                    }
                  },
                },
              }),
              _vm._v("\n\t\t\t\t" + _vm._s(t) + "\n\t\t\t"),
            ]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-default",
          attrs: { type: "button" },
          on: { click: _vm.resetQuery },
        },
        [_vm._v(_vm._s(_vm.$t("formConcept.conceptSearchBox.clear")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }